export const feedbackStates = [
  { value: 0, label: '待回复', class: 'to-be-reply' },
  { value: 1, label: '已回复', class: 'replied' },
  { value: -1, label: '已取消', class: 'canceled' },
];

export const userTypes = [
  { value: 0, label: '北京汽车APP用户' },
  { value: 1, label: '北汽员工' },
];
